<script lang="ts">
import { defineComponent } from "vue";
import { getProbeLabel } from "@/shared/utils/probes";
import ProbeLastValue from "@/features/probe/ProbeLastValue.vue";
import ProbeParams from "@/features/probe/ProbeParams.vue";
import { injectProbe } from "@/shared/utils/injection";
import OutModePicker from "@/features/out/OutModePicker.vue";
import SaveBanner from "@/features/probe/SaveBanner.vue";
import OutQuantities from "@/features/pool/dashboard/OutQuantities.vue";

export default defineComponent({
  ...injectProbe,
  components: {
    OutQuantities,
    SaveBanner,
    OutModePicker,
    ProbeParams,
    ProbeLastValue,
  },
  data() {
    return {
      showConfirm: false,
    };
  },
  computed: {
    label() {
      return getProbeLabel(this.probe.index);
    },
  },
});
</script>

<template>
  <div class="probe-view">
    <save-banner
      :label="$t(label)"
      :io-type="2"
      :io-index="probe.index"
      :with-chart="!$route.params.poolId?.startsWith('ble:')"
    />

    <div
      class="grid gap-2 gap-x-10 lg:max-w-3xl lg:mx-auto"
      :class="out ? 'lg:grid-cols-2' : ''"
    >
      <div>
        <probe-last-value class="mb-2" />
        <probe-params :out="out" />
      </div>

      <out-mode-picker v-if="out" />
    </div>
  </div>
</template>
